import * as React from 'react';

import { DatabasesDisplayPlacePageData, TablesDisplayPlacePageData } from '@tableau/data-catalog-client-components';
import { ActionsMenu } from '../../../app/spaces/ActionsMenu/ActionsMenu';
import { mapGraphTypeToContentInfoForActions } from '../../../ts/mappers/DatabaseAndTableMapper';

export function renderDatabasesActionMenu(database: DatabasesDisplayPlacePageData): JSX.Element {
  return <ActionsMenu targetItems={[mapGraphTypeToContentInfoForActions(database)]} useIcon={true} />;
}

export function renderTablesActionMenu(table: TablesDisplayPlacePageData): JSX.Element {
  return <ActionsMenu targetItems={[mapGraphTypeToContentInfoForActions(table)]} useIcon={true} />;
}
